import React from "react";
import "../css/returns.scss";

function Returns() {
  return (
    <div className="page-width page-width--narrow section-template--27768163107198__main-padding">
      <h1 className="main-page-title page-title h0">Return Policy</h1>
      <div className="rte">
        <h2>Want to return your stationery goods?</h2>
        <p className="p1">
          <span className="s2">
            Please note that pittleforestandco is unable to accept any returns or
            exchanges without the original proof of purchase.
          </span>
        </p>
        <p>&nbsp;</p>
        <h3>
          <strong />
          <span className="s1">
            <b>Store Purchases</b>
          </span>
        </h3>
        <p className="p2">
          For returns or exchanges of purchases made in-store, please refer to
          the Return Policy printed on your receipt. You need a receipt to make
          a return.
        </p>
        <h3 className="p2">
          <b>Online Purchases</b>
        </h3>
        <p className="p1">
          <span className="s2">
            For online purchases, notify us by email,&nbsp;
            <a href="mailto:round@pittleforestandco.shop">
              <span className="s3">round@pittleforestandco.shop</span>
            </a>
            , within 14 days of receipt of your purchase If you wish to return
            your item for a refund or exchange.
            <span className="Apple-converted-space">&nbsp; </span>After
            receiving approval from pittleforestandco, the item needs to be posted
            back to us within 14 days along with the proof of purchase. The item
            must be unused in the original packaging, and in the same condition
            that you received it.*
          </span>
        </p>
        <p className="p1">
          <strong>
            <span className="s2">
              *{" "}
              <em>
                The return period is extended until the 31st of January 2026 for
                any purchases in our stores or online made during the 1st of
                November until the 24th of December 2025.
              </em>
            </span>
          </strong>
        </p>
        <p className="p1">
          <span className="s2">
            pittleforestandco is not responsible for any return postage costs.
            <span className="Apple-converted-space">&nbsp; </span>We recommend
            that you obtain a tracking number and insurance from your
            courier/delivery service in case the package you are returning is
            lost or damaged.
          </span>
        </p>
        <p className="p1">
          <span className="s2">
            Any returns or exchanges which are returned outside of our return
            period, damaged, worn, or unaccompanied by the original proof of
            purchase will not be accepted and will be returned to the customer.
          </span>
        </p>
        <p className="p1">
          <span className="s2">
            We do not accept returns on personalised items or Gift Cards.
          </span>
        </p>
        <p className="p1">
          <span className="s2">
            Please do not send your purchase back to the manufacturer.
          </span>
        </p>
        <h3 className="p1">
          <strong>
            <span className="s1">Refunds</span>
          </strong>
        </h3>
        <p className="p1">
          <span className="s2">
            Once your returned item is received and inspected, you will be
            notified by email if your refund request has been approved.
          </span>
        </p>
        <p className="p1">
          <span className="s2">
            Approved returns will be refunded by the original method of payment
            within 10 working days.
            <span className="Apple-converted-space">&nbsp; </span>Once
            processed, debit card/credit card refunds can take up to 5 working
            days to appear in your account.&nbsp;
          </span>
        </p>
        <h3 className="p1">
          <b>Gift Returns</b>
        </h3>
        <p className="p1">
          <span className="s2">
            To return a gift that has been delivered to you directly from
            pittleforestandco, you can request a merchandise exchange or online gift
            card by contacting us at{" "}
            <a href="mailto:round@pittleforestandco.shop">
              <span className="s3">round@pittleforestandco.shop</span>
            </a>{" "}
            for approval. You will need your gift receipt.
          </span>
        </p>
        <p className="p1">
          <span className="s2">
            You will be notified once the returned item is received and
            inspected by pittleforestandco and advised if your exchange/credit request
            has been approved.
          </span>
        </p>
        <p className="p1">
          <span className="s2">
            Exchanges will only be offered for products in perfect condition,
            with the original packaging, for non-discontinued collections or
            lines, and will be valued at the current retail price.
          </span>
        </p>
        <p className="p1">
          <span className="s2">
            pittleforestandco is not responsible for any return postage costs.
            <span className="Apple-converted-space">&nbsp; </span>We recommend
            that you obtain a tracking number and insurance from your
            courier/delivery service in case the package you are returning is
            lost or damaged.
          </span>
        </p>
        <p className="p1">
          <span className="s2">
            We can not offer an exchange or credit for gift purchases that are
            not marked ‘Gift’ at the time of purchase.
          </span>
        </p>
        <h2 className="p1">
          <span className="s1">
            <b>Return Address</b>
          </span>
        </h2>
        <p className="p1">
          <span className="s2">Please send returns to:</span>
        </p>
        <h3 className="p3">
          <span className="s2">
            <b>pittleforestandco</b>
          </span>
        </h3>
        <p>&nbsp;</p>
        <p className="p3">
          <span>Online&nbsp;Returns</span>
          <span>
            <br />
            21 Sydney Street
            <br />
            Brighton
            <br />
            BN1 4EN
            <br />
            UNITED KINGDOM
          </span>
        </p>
        <p className="p3">-</p>
        <p>
          <b>
            Christmas Returns&nbsp;Policy
            <span />
          </b>
        </p>
        <p className="p1">
          <meta charSet="utf-8" />
          The return period is extended until the 31st of January 2026 for any
          purchases in our stores or online made during the 1st of November
          until the 24th of December 2025.&nbsp;
        </p>
        <p className="p3">&nbsp;</p>
      </div>
    </div>
  );
}

export default Returns;
